module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"UnitsOrSublots\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/units-or-sublots/units-or-sublots.component.html
// module id = ./src/app/units-or-sublots/units-or-sublots.component.html
// module chunks = main